var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar-wrapper" }, [
    _c(
      "div",
      { staticClass: "navbar-left" },
      [
        _c("hamburger", {
          staticClass: "hamburger-container",
          attrs: {
            toggleClick: _vm.toggleSideBar,
            isActive: _vm.sidebar.opened
          }
        }),
        _vm._v(" "),
        _c("breadcrumb", { staticClass: "breadcrumb-container" })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "navbar-right" },
      [
        _c("el-tooltip", { attrs: { content: "全屏", placement: "bottom" } }, [
          _c(
            "span",
            {
              staticClass: "navbar-icon-btn",
              on: { click: _vm.toggleFullScreen }
            },
            [_c("svg-icon", { attrs: { "icon-class": "fullscreen" } })],
            1
          )
        ]),
        _vm._v(" "),
        _c("el-badge", { staticClass: "navbar-badge", attrs: { value: 3 } }, [
          _c("span", { staticClass: "navbar-icon-btn" }, [
            _c("i", { staticClass: "el-icon-bell" })
          ])
        ]),
        _vm._v(" "),
        _c("language-switch"),
        _vm._v(" "),
        _c(
          "el-dropdown",
          { staticClass: "avatar-container", attrs: { trigger: "click" } },
          [
            _c("div", { staticClass: "avatar-wrapper" }, [
              _c("img", {
                staticClass: "user-avatar",
                attrs: { src: _vm.avatar || _vm.defaultAvatar }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "user-name" }, [
                _vm._v(_vm._s(_vm.name || "管理员"))
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-arrow-down" })
            ]),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              {
                staticClass: "user-dropdown",
                attrs: { slot: "dropdown" },
                slot: "dropdown"
              },
              [
                _c(
                  "el-dropdown-item",
                  [
                    _c(
                      "router-link",
                      { staticClass: "dropdown-link", attrs: { to: "/" } },
                      [
                        _c("i", { staticClass: "el-icon-s-home" }),
                        _vm._v(" 首页\n          ")
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-item",
                  [
                    _c(
                      "router-link",
                      { staticClass: "dropdown-link", attrs: { to: "/ums" } },
                      [
                        _c("i", { staticClass: "el-icon-user-solid" }),
                        _vm._v(" 个人中心\n          ")
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-dropdown-item", { attrs: { divided: "" } }, [
                  _c(
                    "span",
                    { staticClass: "dropdown-link", on: { click: _vm.logout } },
                    [
                      _c("i", { staticClass: "el-icon-switch-button" }),
                      _vm._v(" 退出登录\n          ")
                    ]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797e31be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797e31be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = null
// module chunks = 